export type Site = {
  siteId: string;
  siteName: string;
};

// undefined = "All Sites"
export const isValidSiteSelection = (
  sites: Site[],
  siteId: string | undefined,
) => siteId === undefined || sites.some((site) => site.siteId === siteId);
